export default "__VITE_ASSET__pUhpzarc__"